import { useMeQuery } from '@/api'

export const usePollSubscription = (pollInterval: number = 1000) => {
  const { data } = useMeQuery({ pollInterval })
  const subscription = data?.me?.subscription
  return subscription
}
